import * as yup from 'yup'

const MIN_LENGTH_STRING_MESSAGE = 'Field may not be shorted than 1 characters'
const MAX_LENGTH_STRING_MESSAGE = 'Field may not be greater than 255 characters'
const REQUIRED_STRING_MESSAGE = 'Field is required'

export const requiredString = () => yup.string().min(1, MIN_LENGTH_STRING_MESSAGE).max(255, MAX_LENGTH_STRING_MESSAGE).required(REQUIRED_STRING_MESSAGE)
